import { type AppliedAttributeFilter, type AttributeFilter } from '@kijiji/generated/graphql-types'

import { type AttributeFilterColorData } from '@/components/srp/filters/filter-types/styled'
import { type FilterValuesUnion } from '@/components/srp/filters/FiltersAccordion/FiltersAccordion'
import {
  ATTRIBUTE_FILTER_COLORS,
  AttributeColorVisualMap,
} from '@/features/attributes/constants/attributes'
import { type NullableFields } from '@/utils/types'

export const getLabelFromSelectedValue = (
  value: string,
  filterOptions: AttributeFilter['values']
) => {
  const selectedOption = filterOptions?.find((option) => value === option.value)
  return selectedOption && selectedOption.label
}

export function hasValuesProperty(
  value: FilterValuesUnion
): value is NullableFields<Omit<AppliedAttributeFilter, 'filterName'>> {
  return (value as AppliedAttributeFilter).values !== undefined
}

export const getOuterBorderColor = ({ colorName, colorValue }: AttributeFilterColorData) => {
  const colorConfig = AttributeColorVisualMap[colorName]
  if (colorConfig?.borderColor) return colorConfig.borderColor

  return colorValue
}

export const isValidColor = (value: string): value is ATTRIBUTE_FILTER_COLORS => {
  return Object.values(ATTRIBUTE_FILTER_COLORS).includes(value as ATTRIBUTE_FILTER_COLORS)
}
